import { ColumnModel, FilterModel } from '../../filter';

export const ProductFilterKey = 'PRODUCT_FILTER';
export const ProductOrderKey = 'PRODUCT_ORDER';

export const ProductFilterColumns = ['description', 'assetsCount', 'routines', 'alerts', 'filesCount', 'addonsCount', 'createdAt', 'updatedAt'];

export class ProductFilterModel implements FilterModel, ColumnModel {
  keyword?: string;
  workspaceId?: string;
  columns?: string[];

  constructor(data?: any) {
    this.keyword = data?.keyword;
    this.workspaceId = data?.workspaceId;
    this.columns = data?.columns || ['description', 'assetsCount', 'routines', 'alerts', 'filesCount', 'addonsCount', 'createdAt', 'updatedAt'];
  }

  public getColumnsCount(): number {
    return this.columns && this.columns.length > 0 ? this.columns.length : 0;
  }

  public getGraphQLFilter(): any {
    const filter = {} as any;

    if (this.workspaceId) {
      filter.workspaceId = this.workspaceId;
    }

    if (this.keyword) {
      filter.keyword = this.keyword;
    }

    return filter;
  }
}
